<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <!--    Description card-->
    <app-admin-card-with-title
      [cardTitle]="t('event.info.description')"
      [isContentVisible]="!isDescriptionCollapsed" [showToggleButton]="true" [removeTopMargin]="true">
      <div class="row">
        <div class="col-12 col-lg-8">
          <app-rich-text-editor-wrapper (contentChange)="onDescriptionChangeEvent($event)" [disabled]="disableEditing"
                                        [content]="currentEventItem?.description"/>
        </div>
        <div class="col-12 col-lg-4">
          <div class="h-100">
            <app-drag-and-drop [selectedFile]="inputForm.value.descriptionImage"
                               (fileChange)="descriptionImageChange($event)" [isDisabled]="disableEditing"
                               [useWithCropper]="true"
                               [isFullHeight]="true"></app-drag-and-drop>
          </div>
        </div>
      </div>
    </app-admin-card-with-title>

    <!--    Rules card-->
    <app-admin-card-with-title
      [cardTitle]="t('event.info.rules')"
      [isContentVisible]="!isRulesCollapsed" [showToggleButton]="true">
      <div class="row">
        <div class="col-12 col-lg-8">
          <app-rich-text-editor-wrapper (contentChange)="onRulesChangeEvent($event)" [disabled]="disableEditing"
                                        [content]="currentEventItem?.rules"/>
        </div>
        <div class="col-12 col-lg-4">
          <div class="h-100">
            <app-drag-and-drop [selectedFile]="inputForm.value.rulesImage" (fileChange)="rulesImageChange($event)"
                               [isDisabled]="disableEditing" [useWithCropper]="true" [isFullHeight]="true"/>
          </div>
        </div>
      </div>
    </app-admin-card-with-title>
    <!--    Prise fund-->
    <app-admin-card-with-title
      [cardTitle]="t('event.info.prise.fund')"
      [isContentVisible]="!isPriseFundCollapsed" [showToggleButton]="true">
      <app-rich-text-editor-wrapper (contentChange)="onPriseFundChangeEvent($event)" [disabled]="disableEditing"
                                    [content]="currentEventItem?.awardFund"/>
    </app-admin-card-with-title>
    <!--   Video H -->
    <app-admin-card-with-title
      [cardTitle]="t('event.horizontal.video')"
      [isContentVisible]="!isPriseFundCollapsed" [showToggleButton]="true">
      @if (videoHorLinkIsValid()) {
        <app-youtube-embed [youtubeUrl]=mediaVideoHor [width]="560" [height]="315"></app-youtube-embed>
      }
      <div class="pb-3">
        <app-language-input [inputForm]="inputForm" [defaultLanguage]="currentEventItem?.defaultLanguage"
                            [required]="false" [hrKey]="'mediaContentHor'" [enKey]="'mediaContentHorEng'"
                            [itKey]="'mediaContentHorIta'"
                            [siKey]="'mediaContentHorSlo'" [hrLabel]="'event.video'" [enLabel]="'event.video.Eng'"
                            [itLabel]="'event.video.Ita'" [siLabel]="'event.video.Slo'"/>
      </div>
      <app-input formControlName="mediaContentVideoHor" label="{{t('add.video.link')}}"></app-input>
    </app-admin-card-with-title>


    <!--   Video V-->
    <app-admin-card-with-title
      [cardTitle]="t('event.vertical.video')"
      [isContentVisible]="!isVerticalVideoCollapsed" [showToggleButton]="true">
      @if (videoVertLinkIsValid()) {
        <app-youtube-embed [youtubeUrl]=mediaVideoVert [width]="315" [height]="560"></app-youtube-embed>
      }
      <div class="pb-3">
        <app-language-input [inputForm]="inputForm" [defaultLanguage]="currentEventItem?.defaultLanguage"
                            [hrKey]="'mediaContentVert'" [enKey]="'mediaContentVertEng'" [itKey]="'mediaContentVertIta'"
                            [siKey]="'mediaContentVertSlo'" [hrLabel]="'event.video'" [enLabel]="'event.video.Eng'"
                            [itLabel]="'event.video.Ita'" [siLabel]="'event.video.Slo'"/>
      </div>
      <app-input formControlName="mediaContentVideoVert" label="{{t('add.video.link')}}"/>
    </app-admin-card-with-title>
    <!--    Contact information-->
    <app-admin-card-with-title
      [cardTitle]="t('event.info.contact.information')"
      [isContentVisible]="!isContactInformationCollapsed" [showToggleButton]="true">
      <div class="row mb-4">
        <div class="col-12">
          <div class="d-flex flex-column flex-lg-row">
            <div class="form-check form-switch mb-4" style="margin-top: 2.5rem;">
              <input class="form-check-input" type="checkbox" id="measurementByStotinka"
                     formControlName="measurementByStotinka">
              <label class="form-check-label" for="measurementByStotinka">
                {{ t("event.info.contact.measurementByStotinka") }}
                @if (inputForm.controls['measurementByStotinka'].errors?.['required']) {
                  <span>*</span>
                }
              </label>
              @if (inputForm.controls['measurementByStotinka'].touched) {
                @for (errorMessage of inputForm.controls['measurementByStotinka']!.errors |
                  errorMessages:'measurementByStotinka';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }} </span>
                }
              }
            </div>
            <div class="ps-0 ps-lg-4 w-300">
              <app-input formControlName="eMail" label="event.info.email"/>
            </div>
          </div>
        </div>
      </div>
      <div class="field-title">
        <div class="d-flex align-items-center justify-content-between">
          <span class="fw-bold">{{ t('event.info.contact.addNewContact') }}</span>
          <button type="button" class="btn btn-min-height btn-small btn-text" style="font-size: medium;"
                  [disabled]="disableEditing" (click)="addPhone()">
            <i class="bi bi-plus-circle pe-2"></i>{{
              t("event.info.contact.addNewContact.event")
            }}
          </button>
        </div>
      </div>
      <ng-container formArrayName="phones">
        @for (periodForm of phones.controls;let idx = $index;track periodForm) {
          <ng-container>
            <ng-container [formGroupName]="idx">
              <div class="row" [ngClass]="{'pt-2': idx===0}" style="margin-top: 2rem;">
                <div class="col-12 col-lg-4">
                  <div class="form-floating">
                    <app-tel-input [formControlName]="'phone'" [label]="t('organiser.details.phone')"
                                   [numberPlaceholder]="t('organiser.details.phone')"></app-tel-input>
                  </div>
                </div>
                <div class="col-4 col-lg-4">
                  @if (idx === 0) {
                    <app-input ngDefaultControl formControlName="contactName"
                               label="{{t('event.info.contact.name')}}"></app-input>
                  }
                  @if (idx > 0) {
                    <app-language-input [inputForm]="getPhoneGroup(idx)"
                                        [defaultLanguage]="currentEventItem?.defaultLanguage" [hrKey]="'contactName'"
                                        [enKey]="'contactNameEng'" [itKey]="'contactNameIta'" [siKey]="'contactNameSlo'"
                                        [hrLabel]="'event.info.contact.name'" [enLabel]="'event.info.contact.name'"
                                        [itLabel]="'event.info.contact.name'" [siLabel]="'event.info.contact.name'"/>
                  }
                </div>
                @if (idx > 0) {
                  <div class="col-1" style="margin-top: 3.5rem;">
                    <span class="delete-icon" (click)="deletePhone(idx)"><i class="bi bi-trash-fill"></i></span>
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        }
      </ng-container>
    </app-admin-card-with-title>
    <app-action-buttons-row (onSave)="onSave()"/>
  </form>
</ng-container>
